import moment from 'moment-timezone'

export const tableToApiParams = params => ({
  current_page: params.page,
  per: params.pageSize,
  sort_attr: params.sortColumn,
  sort_dir: params.sortOrder,
  filters: {
    conjunction: params.filterConjunction,
    rules: params.filterRules,
  },
})

export const handleUtcDateTime = (rule, userTimezone) => {
  if (rule.operator === 'is') {
    return {
      ...rule,
      operator: 'between',
      param: [
        moment.tz(rule.param, userTimezone).startOf('day').toISOString(),
        moment.tz(rule.param, userTimezone).endOf('day').toISOString(),
      ],
    }
  }

  if (rule.operator === 'before') {
    return {
      ...rule,
      param: moment.tz(rule.param, userTimezone).startOf('day').toISOString(),
    }
  }

  if (rule.operator === 'after') {
    return {
      ...rule,
      param: moment.tz(rule.param, userTimezone).endOf('day').toISOString(),
    }
  }

  return rule
}
